module.exports = "https://static.energy5.com/_next/static/images/step3Image-953631eca52c2167340156226d58317f.jpg";